import React from "react";
import { Redirect } from "react-router-dom";
import useNormalizedURI from "../hooks/useNormalizedURI";

const Three0One = ({ to, from }) => {
  const redirectUrl = useNormalizedURI().segment([to]);
  return (
    <Redirect
      to={{
        pathname: to,
        state: { referrer: from, redirectUrl }
      }}
    />
  );
};

export default Three0One;
